import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>

            <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
                <div className="container">
                    <h2 className="breadcrumb-title">Our Gallery</h2>
                    <ul className="breadcrumb-menu">
                        <li><Link to="/">Home</Link></li>
                        <li className="active">Our Gallery</li>
                    </ul>
                </div>
            </div>

            <div className="gallery-area py-100" style={{marginTop:"-50px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mx-auto">
                            <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <span className="site-title-tagline"><i className="fas fa-solar-panel" />our Gallery</span>
                                <h2 className="site-title">Let's Check Our Photo <span>Gallery</span></h2>
                                <div className="heading-divider" />
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 popup-gallery">
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/g1.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/g1.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/g2.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/g2.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/g3.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/g3.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/g4.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/g4.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/g5.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/g5.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/01.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/01.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/02.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/02.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/03.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/03.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/04.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/04.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/05.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/05.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/06.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/06.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/07.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/07.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/08.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/08.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area py-100" style={{marginTop:"-180px"}}>
                <div className="container">
                    <div className="row g-4 popup-gallery">
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/09.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/09.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/10.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/10.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/11.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/11.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/12.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/12.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/13.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/13.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/14.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/14.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/15.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/15.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/16.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/16.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area py-100" style={{marginTop:"-180px"}}>
                <div className="container">
                    <div className="row g-4 popup-gallery">
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/17.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/17.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/18.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/18.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/19.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/19.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/20.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/20.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/22.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/22.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/23.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/23.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/24.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/24.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/25.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/25.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gallery-area py-100" style={{marginTop:"-180px"}}>
                <div className="container">
                    <div className="row g-4 popup-gallery">
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/26.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/26.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/27.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/27.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/28.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/28.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInDown" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInDown' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/29.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/29.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="gallery-item wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="gallery-img">
                                    <img src="assets/yog/30.webp" alt />
                                </div>
                                <div className="gallery-content">
                                    <a className="popup-img gallery-link" to="assets/yog/30.webp"><i className="fal fa-plus" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Gallery